/**
 * @generated SignedSource<<6fbfea4fe15a07fc413f8f2d193166de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssignLocationModal_getmachineQuery$variables = {
  id: string;
};
export type AssignLocationModal_getmachineQuery$data = {
  readonly getmachine: {
    readonly id: string;
    readonly uuid: string | null;
  };
};
export type AssignLocationModal_getmachineQuery = {
  response: AssignLocationModal_getmachineQuery$data;
  variables: AssignLocationModal_getmachineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MachineObjectType",
    "kind": "LinkedField",
    "name": "getmachine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignLocationModal_getmachineQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignLocationModal_getmachineQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "76e43bbca1c751667b9febc2c19f0899",
    "id": null,
    "metadata": {},
    "name": "AssignLocationModal_getmachineQuery",
    "operationKind": "query",
    "text": "query AssignLocationModal_getmachineQuery(\n  $id: String!\n) {\n  getmachine(id: $id) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

(node as any).hash = "61f09e738eb5e4096a85fc3668d759e7";

export default node;
